import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "localization-form",
  class LocalizationForm extends WYATTElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.input = this.querySelector("[data-input]");
      this.values = this.querySelectorAll("[data-value]");

      this.values.forEach((value) =>
        value.addEventListener("click", this.submit.bind(this)),
      );
    }

    submit(event) {
      this.input.value = event.currentTarget.dataset.value;
      this.form.requestSubmit();
    }
  },
);
